module.exports = __webpack_public_path__ + "static/johnrobbins-headshot.54014228.jpg";